import api from './api';

export default {
  getUserFeatureFlags() {
    return api.get('/feature-flag/for-user/').then(({ data }) => data);
  },
};
